import React from 'react';
import { Helmet } from 'react-helmet';
import { Box } from '@cp/ds/src/components/box';
import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { RouteConfigComponentProps } from 'react-router-config';
import { RoutedLink } from 'src/shared/ui/link';
import Header from 'src/widgets/header';
import { PrivacyPolicyWidget } from 'src/widgets/legal';

const PrivacyPolicy: React.FC<RouteConfigComponentProps> = () => {
  return (
    <Box>
      <Helmet>
        <title>Политика конфиденциальности - YouHelp.ru</title>
      </Helmet>

      <Header />

      <Container sx={{ mb: { xs: 4, md: 8 } }}>
        <Breadcrumbs
          LinkComponent={RoutedLink}
          items={[
            {
              path: '/',
              label: 'Главная',
            },
            {
              path: '',
              label: 'Политика конфиденциальности',
            },
          ]}
          sx={{ my: 2 }}
        />
        <PrivacyPolicyWidget />
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
